<template>
<div class="pa-body">

    <div class="f18 mb20">General</div>
    <div class="section mb20" v-if="settings">
        <label class="mb15">
            <input type="checkbox" v-model="settings.is_active">
            <div>
                <div>Activado</div>
                <div class="secondary-text">Determina si el sitio web del menú virtual está habilitado.</div>
            </div>
            <div class="checkmark"></div>
        </label>        

        <input-field
        v-model="settings.url"
        label="Dominio"
        placeholder="dominio.cl (sin www, sin http://)">
            <div class="append" slot="after" v-if="Auth.role=='admin' || Auth.role == 'sub_admin'">
                <domain-options :domain="settings.url"></domain-options>
            </div>
        </input-field>

    </div>


    <div class="f18 mb20">Personalización</div>
    <div v-if="settings" class="section mb20">

        <div class="hdvm mini">

            <input-image class="mb15"
            label="Banner"
            v-model="settings.banner"
            path="banners/">
            </input-image>
            
            <multiple-images-selector v-model="settings.carousel" label="Carrusel" imagePath="banners/">
            </multiple-images-selector>
        </div>

        <input-field
        label="Descripción"
        description="Descripción de la página web presente en buscadores y al compartir enlace"
        v-model="settings.description">
        </input-field>

        <div class="flex mt20">
            <div class="flex-fill">
                <div class="bold">Personalizar Apariencia</div>
                <div class="secondary-text">Cambia los colores, tipografía y formas de la página web</div>
            </div>
            <button class="secondary" @click="$refs.customizationForm.Open(settings, 'STYLE', 'VIRTUAL_MENU', settings.url)">Editar</button>
        </div>
        <div class="flex mt15">
            <div class="flex-fill">
                <div class="bold">Secciones personalizadas</div>
                <div class="secondary-text">Crea bloques de contenido a tu medida para destacar información importante como promociones, descripciones, etc.</div>
            </div>
            <button class="secondary" @click="$refs.modalExtraDataSections.Open(Util.Copy(settings.extra_data))">Editar</button>
        </div>
    </div>

    <div class="section mb20" v-if="settings">

            <input-select class="mb15"
            label="Precio del menú"
            description="Determina como se mostrará el precio de los productos en la página"
            :items="optionsItemPrice"
            v-model="settings.item_price_display">
            </input-select>

            <input-select class="mb15"
            label="Visualización del menú"
            description="Determina como se mostrará el menú en la página"
            :items="[
                {text: 'Todos los productos', value: 'ALL', description: 'Se muestran todos los productos a la vez, para desplazarse entre secciones se hace scroll'},
                {text: 'Expandir secciones', value: 'EXPAND', description: 'Se muestran las secciones que se pueden expandir para mostrar los productos'},
                {text: 'Separar secciones', value: 'TABS', description: 'Sólo se muestran los productos de la sección seleccionada'}
            ]"
            v-model="settings.menu_display">
            </input-select>

            <input-toggle class="mb15"
            v-model="settings.item_details"
            label="Ver detalles de productos"
            description="Permite seleccionar un producto que abre una ventana con la información y modificadores">
            </input-toggle>

            <div class="flex column">
                <div class="flex align-center">
                    <label>
                        <input type="checkbox" v-model="settings.show_supersection">
                        <div class="checkmark"></div>
                    </label>
                    <div class="flex-fill">
                        <div class="bold">Mostrar super secciones </div>
                        <div class="secondary-text">Al estar activado no se mostrará la sección "Más Vendidos"</div>
                    </div>
                </div>
            </div>

        </div>

    <div class="f18 mb20">Analíticas</div>
    <div class="section" v-if="settings">
        
        <input-field class="mb15"
        v-model="settings.google_analytics"
        label="Google Analytics ID"
        placeholder="G-XXXXXXXXXXX (Opcional)">
        </input-field>
        
        <input-field class="mb15"
        v-model="settings.facebook_pixel"
        label="Facebook Pixel ID"
        placeholder="123456789012345 (Opcional)">
        </input-field>

        <input-field
        v-model="settings.facebook_pixel_access_token"
        label="Facebook Pixel Token de Acceso"
        placeholder="Token de Acceso (Opcional)">
        </input-field>
    </div>

    <customization-form
    ref="customizationForm"
    @OnSaved="SaveCustomization($event)">
    </customization-form>
    <modal-extra-data-sections
    ref="modalExtraDataSections"
    @OnSave="SaveExtraData($event)"
    ></modal-extra-data-sections>
</div>
</template>

<script>
import MultipleImagesSelector from '../common/MultipleImagesSelector.vue';
import CustomizationForm from '../common/CustomizationForm.vue';
import DomainOptions from '../common/DomainOptions.vue';

export default {
    components: { CustomizationForm, DomainOptions, MultipleImagesSelector },
    data() {
        return {
            settings: null,
            optionsItemPrice: [
                {value: 'ITEM_PRICE', text: 'Producto', description: 'Precio del producto'},
                {value: 'MODIFIER_PRICE', text: 'Modificador', description: 'Precio del primer modificador, si no hay se mostrará el precio del producto'},
                {value: 'AUTO', text: 'Auto', description: 'Precio del producto, si no hay se mostrará el precio de un modificador, si no hay se oculta'},
                {value: 'HIDDEN_ZERO', text: 'Productos con precio', description: 'Precio del producto pero no se mostrará si el precio es cero'},
                {value: 'HIDDEN_ALL', text: 'Oculto', description: 'No mostrará el precio'},
            ],
        }
    },
    mounted() {        
        
    },
    methods: {    
        Init(force)
        {
            if(force || !this.settings)
            {
                this.Loading();
                axios.get(`/settings/virtualmenu/${this.Local.id}`).then(res => {
                    this.Response(res);
                    this.settings = res.data;
                }).catch(err => {
                    this.Response(err);
                });
            }
        },
        Save() {
            
            if(this.settings.url)
            {
                if(!this.Util.IsValidInfluyeDomain(this.settings.url))
                    return this.Info('Dominio inválido');
            }

            this.Loading();
            axios.post(`/settings/virtualmenu/${this.Local.id}`, this.settings).then(res => {
                this.Info('Configuración guardada.');
            }).catch(err => {
                this.Response(err);
            });

        },
        SaveCustomization(data) {
            this.settings = data;
            this.Save();
            this.$refs.customizationForm.Close();
        },
        SaveExtraData(data) {
            if(!data) return;
            this.$set(this.settings, 'extra_data', data);
            this.$refs.modalExtraDataSections.Close();
        },

    },
}
</script>